import { render } from "./CandlestickChart.vue?vue&type=template&id=369df2d5&scoped=true&ts=true"
import script from "./CandlestickChart.vue?vue&type=script&lang=ts"
export * from "./CandlestickChart.vue?vue&type=script&lang=ts"

import "./CandlestickChart.vue?vue&type=style&index=0&id=369df2d5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369df2d5"]])

export default __exports__